module.exports = __webpack_public_path__ + "static/media/3rdparty_interface_setup.2d372d95.svg";